export default "__VITE_PUBLIC_ASSET__77a3b880__"